import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store";
import { AnnouncementProvider } from "./context/AnnouncementContext";
import App from "./App";
import "./utils/axiosConfig"; // Import axios configuration

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AnnouncementProvider>
        <App />
      </AnnouncementProvider>
    </Provider>
  </React.StrictMode>,
);
